export const filteredData = (data) => {
   let returnArray =  data?.sort((a, b) => {
    // Convert 'us_id' to numbers and compare them for sorting.
    return parseInt(b.us_id || b.id) - parseInt(a.us_id || a.id);
  })
  return returnArray;
}
export const removeSpecialCharacters = (inputString) => {
  return inputString.replace(/[^\w\s]/g, '');
}